<template>
    <div class="text-right">
        <v-container>
      <v-row justify="center">
        <v-col cols="8">
          <v-container class="max-width">
            <v-pagination
              v-model="page"
              class="my-4"
              :length="totalPage"
             @input="paginationPage(page)"

            ></v-pagination>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import RepositoryFactory from "../../../repositories/RepositoryFactory";
const TestManageRepository = RepositoryFactory.get("testManage");
export default ({
    props:{
        orderStatusId:{
            type:Array
        },
        commentStatusValue:{
            type:Array
        },
        interviewStatusValue:{
            type:Array
        },
        contactTutorStatusValue:{
            type:Array
        },
        resultStatusValue:{
            type:Array
        },
        subjectId:{
            type:Array
        },
        orderStateValue:{
             type:Array
        },
        objectId:{
             type:Array
        },
        examsId:{
             type:Array
        },
        getTime:{
             type:Array
        },
        totalItems:{
            type:Number
        },
        appointmentStartTime:{
            type:String
        },
        appointmentEndTime:{
            type:String
        },
        search:{
            type:String
        }
        // page:{
        //     type:Number,
        //     default:1
        // }
    },
    data(){
        return {
            page:1
        }
    },
    create(){
       
    },
    methods:{
        async paginationPage(data){
            const params = {
                page:data,
                appointmentStartTime: this.getTime,
                appointmentEndTime: this.getTime,
                status: this.contactTutorStatusValue,
                interviewStatus: this.interviewStatusValue,
                level: this.examsId,
                subjectId: this.subjectId,
                commentStatus: this.commentStatusValue,
                orderStatus: this.orderStatusId,
                orderState: this.orderStateValue,
                resultStatus: this.resultStatusValue,
                appointmentStartTime:this.appointmentStartTime,
                appointmentEndTime:this.appointmentEndTime,
                search:this.search
            }
            const response = await TestManageRepository.getListTutor(params)
             Bus.$emit("listutor-pagination", response.data.data);
        }
    },
    computed:{
        totalPage(){
            return Math.ceil(this.totalItems / 10)
        },
        
    }
    
})
</script>
